import { FormControl, MenuItem, Select, SelectChangeEvent, GridLegacy as Grid, InputLabel } from "@mui/material";
import { FC, useEffect } from "react";
import { useUserParams } from '../../../context/user-params-context';
import { ReportParameterDatePart } from '../../../logic/api';
import { useTranslation } from "react-i18next";


const ChartIntervalSelector: FC = () => {
  const { userParams, setUserParams, clearParams } = useUserParams();
  const { t } = useTranslation();

  const hourOptions = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, "0")}:00`);
  const weekdayOptions = [t("reports.mon"), t("reports.tue"), t("reports.wed"), t("reports.thur"), t("reports.fri"), t("reports.sat"), t("reports.sun")];
  const monthOptions = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));

  const interval = userParams["@u_interval"] as ReportParameterDatePart;
  const chartInterval = userParams["@u_chartInterval"] ?? getDefaultchartInterval(interval);

  useEffect(() => {
    setUserParams(prev => ({
      ...prev,
      "@u_chartInterval": getDefaultchartInterval(interval)
    }));

    return () => {
      clearParams(['@u_chartInterval']);
    };
  }, [interval]);

  const handleChange = (event: SelectChangeEvent) => {
    setUserParams(prev => ({
      ...prev,
      "@u_chartInterval": event.target.value
    }));
  };

  function getDefaultchartInterval(type: ReportParameterDatePart): string {
    switch (type) {
      case ReportParameterDatePart.Day:
        return "12:00";
      case ReportParameterDatePart.Week:
        return "Monday";
      case ReportParameterDatePart.Month:
        return "01";
      default:
        return "";
    }
  }

  function getSubOptions(): string[] {
    switch (interval) {
      case ReportParameterDatePart.Day:
        return hourOptions;
      case ReportParameterDatePart.Week:
        return weekdayOptions;
      case ReportParameterDatePart.Month:
        return monthOptions;
      default:
        return [];
    }
  }

  function getLabel(): string {
    switch (interval) {
      case ReportParameterDatePart.Day:
        return t("input.criteria.options.day");
      case ReportParameterDatePart.Week:
        return t("input.criteria.options.week");;
      case ReportParameterDatePart.Month:
        return t("input.criteria.options.month");;
      default:
        return "";
    }
  }

  return (
    <Grid item sm={6} md={4}>
      <FormControl fullWidth size="small">
        <InputLabel id="chart-interval-label">{getLabel()}</InputLabel>
        <Select
          labelId="chart-interval-label"
          id="chart-interval-select"
          value={chartInterval}
          label={getLabel()}
          onChange={handleChange}
        >
          {getSubOptions().map((val) => (
            <MenuItem key={val} value={val}>{val}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default ChartIntervalSelector;
